import { z } from 'zod';
import { SyncFrequencySchema } from '../inputTypeSchemas/SyncFrequencySchema'
import { AfterCopySchema } from '../inputTypeSchemas/AfterCopySchema'

/////////////////////////////////////////
// CORE INTEGRATION ESRI LAYER SETTING SCHEMA
/////////////////////////////////////////

export const CoreIntegrationEsriLayerSettingSchema = z.object({
  syncFrequency: SyncFrequencySchema,
  afterCopy: AfterCopySchema,
  id: z.number().int(),
  cityId: z.number().int(),
  userId: z.number().int().nullable(),
  createdAt: z.coerce.date(),
  startedAt: z.coerce.date().nullable(),
  name: z.string(),
  urlPath: z.string(),
  fields: z.string(),
  CoreIntegrationEsriSettingId: z.number().int().nullable(),
  CoreImportDefinitionId: z.number().int().nullable(),
  lastSyncAt: z.coerce.date().nullable(),
})

export type CoreIntegrationEsriLayerSetting = z.infer<typeof CoreIntegrationEsriLayerSettingSchema>

export default CoreIntegrationEsriLayerSettingSchema;
